export const dashboardKeys = {
  all: ['dashboard'] as const,
  leave: (profileId: string) => [...dashboardKeys.all, 'leave', profileId] as const,
  timesheet: (profileId: string) => [...dashboardKeys.all, 'timesheet', profileId] as const,
  scheduledDays: (profileId: string, weekStart: string) => 
    [...dashboardKeys.all, 'scheduledDays', profileId, weekStart] as const,
};
